module.exports = __webpack_public_path__ + "img/panchito_top_right-min.cbba6de1.png";